module.exports = __webpack_public_path__ + "img/img-3-2.382edece.webp";